import { useHistory } from 'react-router-dom'
import type { THref } from '@/router/hooks/types'
import { EUserProfileRoute } from '@/types'

const EXTERNAL_ROUTE_PATTERNS: string[] = [EUserProfileRoute.railwayDeliveryDeals]

export function useNavigate() {
  const history = useHistory()

  return (href: THref, { replace = false } = {}) => {
    // location objects
    if (typeof href === 'object') {
      if (replace) {
        history.replace(href)
      } else {
        history.push(href)
      }

      return
    }

    if (EXTERNAL_ROUTE_PATTERNS.some(route => route.match(href))) {
      window.location.assign(href)

      return
    }

    // string paths
    if (replace) {
      history.replace(href)
    } else {
      history.push(href)
    }
  }
}
